import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=2a6c6c10&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=2a6c6c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c6c10",
  null
  
)

export default component.exports